module.exports = __webpack_public_path__ + "static/sw-shirt-green-a70026ec4b13bcc58dd049cd476c9b40.jpg";